import React from 'react';
import CarMakeImage from '../SubLocationFinder/CarMakeImage';
function LocationCarMakesRow({ location, height = 40 }) {
    return (
        <div className="uk-grid uk-grid-small uk-child-width-auto uk-flex-middle" data-uk-grid="">
            <div style={{ maxWidth: '25%' }}>
                <CarMakeImage height={height} carMake={location.hauptFabrikat} gesellschafterNr={location.gesellschafterNr} />  

            </div>
            {(location.nebenFabrikat || []).map((nebenFabrikat, index) => (
                <div key={index} style={{ maxWidth: '25%' }}>
                    <CarMakeImage height={height} carMake={nebenFabrikat} gesellschafterNr={location.gesellschafterNr} />  
                </div>
            ))}
        </div>
    );
}

export default LocationCarMakesRow;
